import { render, staticRenderFns } from "./balanceRecord.vue?vue&type=template&id=0f6b3501&scoped=true"
import script from "./balanceRecord.vue?vue&type=script&lang=js"
export * from "./balanceRecord.vue?vue&type=script&lang=js"
import style0 from "./balanceRecord.vue?vue&type=style&index=0&id=0f6b3501&prod&scoped=true&lang=css"
import style1 from "./balanceRecord.vue?vue&type=style&index=1&id=0f6b3501&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b3501",
  null
  
)

export default component.exports